import { CountryIsoCode } from '@toasttab/buffet-pui-country-utilities'
import {
  countryIsoCodeForPhoneNumber,
  PhoneNumber
} from '@toasttab/buffet-pui-phone-utilities'
import { phone } from 'phone'

export const getPhoneInfo = (number: string, country?: string) => {
  let phoneInfo = phone(number, { country })
  if (!phoneInfo.isValid) {
    phoneInfo = phone(number, { validateMobilePrefix: false, country })
  }
  return {
    countryCode: phoneInfo.countryCode,
    isValid: phoneInfo.isValid,
    countryIsoCode: phoneInfo.countryIso2 as CountryIsoCode,
    nationalNumber: number
  }
}

/**
 * Determines the country ISO code for the phone input.
 * Handles the special case where US and Canada both use country code '1'.
 */
export const determineCountryIsoCode = (value: PhoneNumber): CountryIsoCode => {
  if (value.countryIsoCode) {
    return value.countryIsoCode
  }

  const fallbackCountry = countryIsoCodeForPhoneNumber(value) || 'US'

  // Special case for US and Canada numbers with countryCode of '1'
  if (value.countryCode === '1') {
    if (!value.nationalNumber) {
      return 'US'
    }
    const parsedPhoneInfo = getPhoneInfo(value.nationalNumber)
    return parsedPhoneInfo.countryIsoCode || 'US'
  }

  return fallbackCountry
}
